module.exports = __webpack_public_path__ + "static/media/yourturnfight.a641b7e4.png";